import React from "react";
import { Reveal } from "../components/Reveal";
import { Overline, SectionTitle } from "../components/site/Primitives";
import SEO from "../components/SEO";

export default function Termos() {
  return (
    <div>
      <SEO title="Termos de Uso | Barbearia das Estrelas" description="Termos de uso do site da Barbearia das Estrelas e Prime Capilar Clinic." />
      <section className="border-b border-white/10 py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <Reveal><Overline className="mb-3">Legal</Overline></Reveal>
          <Reveal delay={0.05}><SectionTitle>Termos de Uso</SectionTitle></Reveal>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-5 lg:px-8 py-16 space-y-5 text-zinc-300 leading-relaxed">
        <p>Ao acessar e utilizar este site, você concorda com os termos descritos abaixo.</p>
        <p><span className="text-white font-600">Conteúdo.</span> As informações, imagens e valores apresentados têm caráter informativo. Os serviços de prótese capilar dependem de avaliação individual.</p>
        <p><span className="text-white font-600">Agendamentos e assinaturas.</span> Os agendamentos e assinaturas do clube estão sujeitos à disponibilidade e às condições vigentes no momento da contratação.</p>
        <p><span className="text-white font-600">Parceria.</span> Em Maceió, o atendimento de prótese capilar acontece em parceria com a Arena Barbearia, empresa parceira independente.</p>
        <p><span className="text-white font-600">Propriedade.</span> Todo o conteúdo deste site pertence à Barbearia das Estrelas e à Prime Capilar Clinic, salvo indicação em contrário.</p>
        <p>Estes termos podem ser atualizados periodicamente.</p>
      </section>
    </div>
  );
}
